import { $authHost, $worker } from ".";
import {
  CreatePaymentLinkRequest,
  CreatePaymentLinkResponse,
  PaymentSuccessPayload,
} from "@/@types/catalog.types";

export async function createPaymentLink(data: CreatePaymentLinkRequest) {
  const response = await $authHost.request<CreatePaymentLinkResponse>({
    url: "/payment_link",
    method: "POST",
    data,
  });
  return response;
}

export async function signPaymentSuccessPayload(payload: PaymentSuccessPayload): Promise<string> {
  const response = await $worker.post<{ token: string }>("/payments/sign", { payload });
  return response.data.token;
}

export async function verifyPaymentSuccessToken(token: string): Promise<PaymentSuccessPayload> {
  const response = await $worker.post<{ payload: PaymentSuccessPayload }>("/payments/verify", {
    token,
  });
  return response.data.payload;
}
